import angular from 'angular';

angular.module('app.core').factory('FolderFilters', FolderFilters);

export default class FolderFilters {
  constructor() {}

  setCreatedDateFrom(createdDateFrom) {
    this.createdDateFrom = createdDateFrom;
  }

  setCreatedDateTo(createdDateTo) {
    this.createdDateTo = createdDateTo;
  }

  setUpdatedDateFrom(updatedDateFrom) {
    this.updatedDateFrom = updatedDateFrom;
  }

  setUpdatedDateTo(updatedDateTo) {
    this.updatedDateTo = updatedDateTo;
  }

  setCompanyName(companyName) {
    this.companyName = companyName;
  }

  setEnvelopeId(envelopeId) {
    this.envelopeId = envelopeId;
  }

  setFolderId(folderId) {
    this.folderId = folderId;
  }

  setFolderStatus(folderStatus) {
    this.folderStatus = folderStatus;
  }

  setPrincipalId(principalId) {
    this.principalId = principalId;
  }

  setRank(rank) {
    this.rank = rank;
  }

  setRefClient(refClient) {
    this.refClient = refClient;
  }

  setSender(sender) {
    this.sender = sender;
  }
  setSenderEmail(senderEmail) {
    this.senderEmail = senderEmail;
  }

  setSenderName(senderName) {
    this.senderName = senderName;
  }
}
